import { render, staticRenderFns } from "./GenealogyPersonPreview.vue?vue&type=template&id=395cd28a&scoped=true&"
import script from "./GenealogyPersonPreview.vue?vue&type=script&lang=ts&"
export * from "./GenealogyPersonPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395cd28a",
  null
  
)

export default component.exports